import React from "react";
import ReactDOM from "react-dom";
import { useContextSelector } from "use-context-selector";
import { Link } from "react-router-dom";
import { t } from "i18next";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import moment from "moment";
import OutsideClickHandler from "react-outside-click-handler";
const DateRangeModal = ({ filter, setFilter, setShow }) => {
  return ReactDOM.createPortal(
    <div className="cdk-overlay-container">
      <div className="cdk-overlay-backdrop dialog-backdrop cdk-overlay-backdrop-showing" />
      <div
        className="cdk-global-overlay-wrapper"
        dir="ltr"
        style={{
          "-webkit-box-pack": "center",
          "-webkit-justify-content": "center",
          "-ms-flex-pack": "center",
          "justify-content": "center",
          "-webkit-align-items": "center",
          "-webkit-box-align": "center",
          "-ms-flex-align": "center",
          "align-items": "center",
        }}
      >
        <div
          id="cdk-overlay-2"
          className="cdk-overlay-pane dialog-panel"
          style={{ position: "static" }}
        >
          <app-dialog _nghost-serverapp-c33280995>
            <div _ngcontent-serverapp-c33280995 className="popup" id="dialog-2">
              <OutsideClickHandler onOutsideClick={() => setShow(false)}>
                <div
                  style={{
                    background: "linear-gradient(to bottom,#2a3838,#131919)",
                    padding: "10px",
                  }}
                  _ngcontent-serverapp-c33280995
                  className="popup__content"
                >
                  <DayPicker
                    mode="range"
                    selected={{
                      from: filter?.startDate
                        ? moment(filter.startDate, "YYYY-MM-DD").toDate()
                        : undefined,
                      to: filter?.endDate
                        ? moment(filter.endDate, "YYYY-MM-DD").toDate()
                        : undefined,
                    }}
                    onSelect={(e) =>
                      setFilter((prev) => {
                        return {
                          ...prev,
                          startDate: e?.from
                            ? moment(e.from).format("YYYY-MM-DD")
                            : undefined,
                          endDate: e?.to
                            ? moment(e.to).format("YYYY-MM-DD")
                            : undefined,
                        };
                      })
                    }
                    style={{
                      "--rdp-accent-color":
                        "#ffb80c" /* selected date → green */,
                      "--rdp-accent-background-color":
                        "#043b3d" /* range highlight → gold */,
                      "--rdp-day-color": "white",
                      color: "white",
                    }}
                    disabled={{ after: new Date() }}
                  />
                </div>{" "}
              </OutsideClickHandler>
            </div>
          </app-dialog>
        </div>
      </div>
    </div>,
    document.getElementById("overlay"),
  );
};

export default DateRangeModal;
